// icons
import {
  MdAttachMoney,
  MdReceipt,
  MdPayments,
  MdMoneyOff,
  MdBarChart
} from "react-icons/md";

const finanzas = {
  id: 'finanzas-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'finanzas',
      title: 'Finanzas',
      type: 'collapse',
      icon: MdAttachMoney,
      children: [
        {
          id: 'finanzas-cxc',
          title: 'CxC',
          type: 'item',
          breadcrumbs: false,
          icon: MdReceipt,
          url: '/finanzas/cxc'
        },
        {
          id: 'finanzas-cobros',
          title: 'Cobros',
          type: 'item',
          breadcrumbs: false,
          icon: MdPayments,
          url: '/finanzas/cobros'
        },
        {
          id: 'finanzas-gastos',
          title: 'Gastos',
          type: 'item',
          breadcrumbs: false,
          icon: MdMoneyOff,
          url: '/finanzas/gastos'
        },
        {
          id: 'finanzas-estado-de-resultados',
          title: 'Estado de resultados',
          type: 'item',
          breadcrumbs: false,
          icon: MdBarChart,
          url: '/finanzas/estado-de-resultados'
        }
      ]
    }
  ]
};

export default finanzas;
